import { useGetScormsQuery } from '@services/scorms'
import { SortStates } from '@templates/ListPageLayout/Filters/Sorter'
import useItemsFilters, { FilterState } from './useItemsFilters'

type Params = {
  initFilters?: FilterState
  pagination?: boolean
  limit?: number
  skip?: boolean
  initOrder?: { order: Record<string, SortStates> }
  forcedFilters?: FilterState
}

const useScorms = (params?: Params) => {
  const {
    initFilters = {},
    pagination = false,
    limit,
    skip,
    initOrder,
    forcedFilters,
  } = params || {}

  const { filters: baseFilters, setFilters, setPage, setOrder } = useItemsFilters(
    initFilters,
    pagination,
    limit,
    initOrder
  )

  const filters = forcedFilters ? { ...baseFilters, ...forcedFilters } : baseFilters

  const state = useGetScormsQuery(filters, {
    skip,
    refetchOnMountOrArgChange: false,
    refetchOnFocus: false,
    refetchOnReconnect: false,
  })

  return {
    ...state,
    setPage,
    setFilters,
    setOrder,
  }
}

export default useScorms
